import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col, Container } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo1 from './img/logo1.png'
import logo2 from './img/logo2.png'

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('es');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'etapa';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = translate("RequestLoginErrorMessage");

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-etapa-container" ref={nodeRef}>
        <Row className='nav__logos-etapa'>
          <Col className="col__logo1-etapa" sm="12" xs="12" md="8" lg="10">
            <img src={logo1} alt="logo1" className="logo-etapa1" />
          </Col>
          <Col className="col__logo2-etapa">
            <img src={logo2} alt="logo" className="logo-etapa2" />
          </Col>
        </Row>
        <Form onSubmit={(event) => onSubmit(event)}>
          <Container fluid={true} className="etapa-form-container">
            <h1 className="desc">{translate("ClientAuthentication")}</h1>
            <div className="etapa-separator"></div>
            <Row className="etapa-form-body form">
              <Col xs="12" sm="10" md="6" lg="3" className="etapa-input">
                <div><p className="detail">{translate("PlaceholderUserName")}</p></div>
                <Input
                  className="user-input-etapa input"
                  disabled={onLogin}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="username"
                  onChange={e => setUsername(e.target.value)}
                  placeholder=""
                />
              </Col>
              <Col xs="12" sm="10" md="6" lg="3" className="etapa-input">
                <div className="detail"><p>{translate("PlaceholderPassword")}</p></div>
                <Input
                  className="pass-input-etapa input"
                  required={true}
                  disabled={onLogin}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password"
                  placeholder=""
                  onChange={e => setPassword(e.target.value)}
                />
              </Col>
              <Col xs="12" sm="10" md="6" lg="3" className="etapa-input">
                {!onLogin ? (
                  <div className="submit-container">
                    <button
                      tabIndex={1}
                      type="submit"
                      id="submmit"
                      className="enter-etapa"
                      disabled={!props.turnstileSuccess}
                    >
                      {translate("ButtonEnter")}
                    </button>
                    <a
                      href="https://mietapa.etapa.net.ec/mi_etapa/HCaPaDGO.aspx"
                      className="submit-container-href_link"
                    >
                      ¿Has olvidado tu contraseña?
                    </a>
                  </div>
                ) : (
                  <Progress animated color="danger" value={100} />
                )}
              </Col>

            </Row>
            <div className="messages-container">
              <Alert
                color="danger"
                id="error-message"
                isOpen={error.open}
                toggle={() => setError({ open: false })}
              >
                {error.message}
              </Alert>
            </div>
            <Row>
              <Col style={{ padding: '0' }} xs="12" sm="10" md="6" lg="3" className="captcha-container">
                <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
              </Col>
            </Row>
          </Container>
        </Form>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
